import React, { useEffect, useState, useContext } from "react";
import { Modal } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { updateDSO } from "../../../services/adminApiService/dsoAPIs/dsoApis";
import notify from "../../../utils/notification";
import swal from "sweetalert";
import { EyePasswordBtn } from "../../../common/ui/view/CustomEyePasswordBtn";
import { AccountManagementContext } from "../../../context/AccountManagementContext";
import { createAccountUser } from "../../../services/adminApiService/accountManagementApi/AccountManagementApiService";


// Validation schema for form fields
const validationSchema = {
    name: {
        required: true,
        pattern: /^[A-Za-z\s]+$/,
        maxLength: 50,
        message: "Name is required and Non-numeric",
    },

    // last_name: {
    //     required: true,
    //     pattern: /^[A-Za-z\s]+$/,
    //     maxLength: 50,
    //     message: "Last name is required and must contain only letters",
    // },
    phone: {
        required: true,
        pattern: /^[6-9]\d{9}$/,
        message: "Enter a valid 10-digit phone number",
    },
    email: {
        required: true,
        pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
        message: "Enter a valid email address",
    },
    password: {
        required: true,
        pattern: /^(?=.*[A-Z])(?=.*\d)(?=.*[@#$!%*?&])[A-Za-z\d@#$!%*?&]{8,15}$/,
        minLength: 8,
        maxLength: 15,
        message: "Password must be 8-15 characters and include at least one uppercase letter, one number, and one special character..",
        requiredMessage: "Password is required",
    },
    confirm_password: {
        required: true,
        matchWith: "password",
        message: "Confirm password must match password",
    },

    state: {
        required: true,
        message: "State is required",
    },
    district: {
        required: true,
        message: "District is required",
    },
    adminCateogry: {
        required: true,
        message: "Assign Role required",
    },
};

const AddAcountManagement = ({ setCurrentPage,debouncedSearchValue, perPage, currentPage }) => {
   
    const {
        loading,
        statesList,
        districtList,
        blockList,
        nyayPanchayatList,
        errors,
        setErrors,
        setFormData,
        formData,
        setIsLoading,
        fetchDSOs,
        showCreateDSO,
        handleClose,
        editData,
        fetchAccountuserAssignRole,
        fetchUserAccountManagementList,
        accountUserAssingData,
        fetchStates,
        fetchDistricts,
        fetchBlocks,
        fetchNyayPanchayats,
        getAccountUserCount
    } = useContext(AccountManagementContext);





    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });

        // Validate field on change
        validateField(name, value);
    };

    // Validation function

    const validateField = (field, value) => {
        const rule = validationSchema[field];
        if (!rule) return;

        const stringValue = value !== undefined && value !== null ? String(value) : "";
        const trimmedValue = stringValue.trim();

        // Required
        if (rule.required && !trimmedValue) {
            setErrors(prev => ({
                ...prev,
                [field]: rule.requiredMessage || rule.message || `${field} is required`,
            }));
            return;
        }

        // Max Length
        if (rule.maxLength && trimmedValue.length > rule.maxLength) {
            setErrors(prev => ({
                ...prev,
                [field]: `Maximum ${rule.maxLength} characters allowed`,
            }));
            return;
        }

        // Min Length
        if (rule.minLength && trimmedValue.length < rule.minLength) {
            setErrors(prev => ({
                ...prev,
                [field]: `Minimum ${rule.minLength} characters required`,
            }));
            return;
        }

        // Pattern
        if (rule.pattern && !rule.pattern.test(trimmedValue)) {
            setErrors(prev => ({
                ...prev,
                [field]: rule.message,
            }));
            return;
        }

        // Confirm Password Match
        if (field === "confirm_password" && trimmedValue !== formData.password) {
            setErrors(prev => ({
                ...prev,
                confirm_password: rule.message,
            }));
            return;
        }

        // Clear Error
        setErrors(prev => {
            const newErrors = { ...prev };
            delete newErrors[field];

            if (
                field === "password" &&
                formData.confirm_password === trimmedValue
            ) {
                delete newErrors.confirm_password;
            }

            return newErrors;
        });
    };


    const validateForm = () => {
        const newErrors = {};
        Object.keys(validationSchema).forEach((field) => {
            validateField(field, formData[field]);
            if (!formData[field]) {
                newErrors[field] = validationSchema[field].message;
            }
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        const levelMap = { district: 3, block: 6, nyay_panchayat: 7 };
        const payload = {
            name: formData.name,
            phone: formData.phone,
            email: formData.email,
            password: formData.password,
            confirm_password: formData.confirm_password,
            state_id: formData.state,
            district_id: parseInt(formData.district),
            usp_role_id: formData.adminCateogry,
            user_level: formData.adminLevel ? levelMap[formData.adminLevel] : undefined,
            block_id: formData.block ? parseInt(formData.block) : undefined,
            nyay_panchayat_id: formData.nyayPanchayat ? parseInt(formData.nyayPanchayat) : undefined,
        };

        try {
            setIsLoading(true);

            const response = editData
                ? await updateDSO(editData?.id, payload)
                : await createAccountUser(payload);

            // ✅ SUCCESS
            if (response?.data?.status === true) {
                swal("Success", response?.data?.message, "success");
                setFormData({});
                setErrors({});
                handleClose();
               
               await fetchUserAccountManagementList(
                    "",
                    "desc",
                    debouncedSearchValue,
                    perPage,
                    1,
                );
                // setCurrentPage(1);
                getAccountUserCount();
                
                return;
            }

            handleBackendErrors(response?.data);

        } catch (error) {
            handleBackendErrors(error.response?.data);
        } finally {
            setIsLoading(false);
        }
    };

    const handleBackendErrors = (data) => {
        if (!data) return;

        // ✅ If backend sends field errors as object
        if (typeof data.message === "object" && data.message !== null) {
            const formattedErrors = {};

            Object.keys(data.message).forEach((field) => {
                formattedErrors[field] = Array.isArray(data.message[field])
                    ? data.message[field][0]
                    : data.message[field];
            });

            setErrors(formattedErrors);
        }

        // ✅ If backend sends single string message
        else if (typeof data.message === "string") {
            notify("error", data.message);
        }

        // ✅ If backend sends errors key instead
        else if (data.errors) {
            const formattedErrors = {};

            Object.keys(data.errors).forEach((field) => {
                formattedErrors[field] = Array.isArray(data.errors[field])
                    ? data.errors[field][0]
                    : data.errors[field];
            });

            setErrors(formattedErrors);
        }

        else {
            notify("error", "Something went wrong.");
        }
    };
    useEffect(() => {
        fetchStates();
    }, [fetchStates]);

    useEffect(() => {
        fetchDistricts(formData.state);
    }, [formData.state, fetchDistricts]);

    useEffect(() => {
        fetchBlocks(formData.district);
        setFormData(prev => ({ ...prev, block: "", nyayPanchayat: "" }));
    }, [formData.district, fetchBlocks]);

    useEffect(() => {
        fetchNyayPanchayats(formData.block);
        setFormData(prev => ({ ...prev, nyayPanchayat: "" }));
    }, [formData.block, fetchNyayPanchayats]);

    useEffect(() => {
        fetchAccountuserAssignRole()
    }, [])

    return (
        <Modal show={showCreateDSO} onHide={handleClose} backdrop="true" centered>
            <form onSubmit={handleSubmit}>
                <div className="modal-header">
                    <h4 className="modal-title fs-20">
                        {editData ? "Edit DSO" : "Add Admin"}
                    </h4>
                    <button type="button" className="btn-close" onClick={handleClose}>
                        <span></span>
                    </button>
                </div>
                <div className="modal-body">
                    <div className="add-contact-box">
                        <div className="add-contact-content">
                            {/* <div className="row">
                                {[
                                    {
                                        label: "Full Name",
                                        name: "name",
                                        type: "text",
                                        placeholder: "First Name",
                                    },

                                    // {
                                    //     label: "Last Name",
                                    //     name: "last_name",
                                    //     type: "text",
                                    //     placeholder: "Last Name",
                                    // },
                                     {
                                        label: "Email Address",
                                        name: "email",
                                        type: "email",
                                        placeholder: "Email",
                                    },
                                    {
                                        label: "Phone Number",
                                        name: "phone",
                                        type: "tel",
                                        placeholder: " Contact Number",
                                    },
                                   
                                    {
                                        label: "Create Password",
                                        name: "password",
                                        type: "password",
                                        placeholder: "Password",
                                    },
                                    {
                                        label: "Confirm Password",
                                        name: "confirm_password",
                                        type: "password",
                                        placeholder: "Confirm Password",
                                    }
                                ].map(({ label, name, type, placeholder }) => (
                                    <div key={name} className="col-md-6 mb-3">
                                        <label className="text-black font-w500">
                                            {label} <span className="text-danger">*</span>
                                        </label>
                                        <div className="password-input-container">
                                            <Form.Control
                                                type={
                                                    name === "password"
                                                        ? showPassword
                                                            ? "text"
                                                            : "password"
                                                        : name === "confirm_password"
                                                            ? showConfirmPassword
                                                                ? "text"
                                                                : "password"
                                                            : type
                                                }
                                                name={name}
                                                value={formData[name]}
                                                placeholder={placeholder}
                                                onChange={handleChange}
                                                isInvalid={!!errors[name]}
                                            />

                                            {name === "password" && (
                                                <EyePasswordBtn
                                                    showPassword={showPassword}
                                                    setShowPassword={setShowPassword}
                                                    hasError={!!errors[name]}
                                                />
                                            )}

                                            {name === "confirm_password" && (
                                                <EyePasswordBtn
                                                    showPassword={showConfirmPassword}
                                                    setShowPassword={setShowConfirmPassword}
                                                    hasError={!!errors[name]}
                                                />
                                            )}
                                        </div>


                                        <Form.Control.Feedback type="invalid" className="d-block">
                                            {errors[name] || errors?.[name]}
                                        </Form.Control.Feedback>


                                    </div>
                                ))}
                            </div> */}


                            <div className="row">
                                {/* Full Name */}
                                <div className="col-md-6 mb-3">
                                    <label className="text-black font-w500">
                                        Full Name <span className="text-danger">*</span>
                                    </label>
                                    <Form.Control
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        placeholder="Full Name"
                                        onChange={handleChange}
                                        isInvalid={!!errors.name}
                                    />
                                    <Form.Control.Feedback type="invalid" className="d-block">
                                        {errors.name}
                                    </Form.Control.Feedback>
                                </div>

                                {/* Email */}
                                <div className="col-md-6 mb-3">
                                    <label className="text-black font-w500">
                                        Email Address <span className="text-danger">*</span>
                                    </label>
                                    <Form.Control
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        placeholder="Email"
                                        onChange={handleChange}
                                        isInvalid={!!errors.email}
                                    />
                                    <Form.Control.Feedback type="invalid" className="d-block">
                                        {errors.email}
                                    </Form.Control.Feedback>
                                </div>
                            </div>

                            <div className="row">
                                {/* Phone */}
                                <div className="col-md-6 mb-3">
                                    <label className="text-black font-w500">
                                        Phone Number <span className="text-danger">*</span>
                                    </label>
                                    <Form.Control
                                        type="tel"
                                        name="phone"
                                        value={formData.phone}
                                        placeholder="Contact Number"
                                        onChange={handleChange}
                                        isInvalid={!!errors.phone}
                                    />
                                    <Form.Control.Feedback type="invalid" className="d-block">
                                        {errors.phone}
                                    </Form.Control.Feedback>
                                </div>

                                {/* Assign Role */}
                                <div className="col-md-6 mb-3">
                                    <label className="text-black font-w500">
                                        Assign Role <span className="text-danger">*</span>
                                    </label>
                                    <select
                                        name="adminCateogry"
                                        className={`form-control ${errors.adminCateogry ? "is-invalid" : ""}`}
                                        value={formData.adminCateogry}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select Assign Role</option>
                                        {accountUserAssingData?.data?.map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.role_name}
                                            </option>
                                        ))}
                                    </select>
                                    <div className="invalid-feedback">{errors.adminCateogry}</div>
                                </div>
                            </div>

                            <div className="row">
                                {/* Password */}
                                <div className="col-md-6 mb-3">
                                    <label className="text-black font-w500">
                                        Create Password <span className="text-danger">*</span>
                                    </label>
                                    <div className="password-input-container">
                                        <Form.Control
                                            type={showPassword ? "text" : "password"}
                                            name="password"
                                            value={formData.password}
                                            placeholder="Password"
                                            onChange={handleChange}
                                            isInvalid={!!errors.password}
                                        />
                                        <EyePasswordBtn
                                            showPassword={showPassword}
                                            setShowPassword={setShowPassword}
                                            hasError={!!errors.password}
                                        />
                                    </div>
                                    <Form.Control.Feedback type="invalid" className="d-block">
                                        {errors.password}
                                    </Form.Control.Feedback>
                                </div>

                                {/* Confirm Password */}
                                <div className="col-md-6 mb-3">
                                    <label className="text-black font-w500">
                                        Confirm Password <span className="text-danger">*</span>
                                    </label>
                                    <div className="password-input-container">
                                        <Form.Control
                                            type={showConfirmPassword ? "text" : "password"}
                                            name="confirm_password"
                                            value={formData.confirm_password}
                                            placeholder="Confirm Password"
                                            onChange={handleChange}
                                            isInvalid={!!errors.confirm_password}
                                        />
                                        <EyePasswordBtn
                                            showPassword={showConfirmPassword}
                                            setShowPassword={setShowConfirmPassword}
                                            hasError={!!errors.confirm_password}
                                        />
                                    </div>
                                    <Form.Control.Feedback type="invalid" className="d-block">
                                        {errors.confirm_password}
                                    </Form.Control.Feedback>
                                </div>
                            </div>

                            <div className="row">
                                <div className="form-group mb-3 col-md-6">
                                    <label className="text-black font-w500">
                                        State <span className="text-danger">*</span>
                                    </label>
                                    <select
                                        name="state"
                                        className={`form-control ${errors.state ? "is-invalid" : ""
                                            }`}
                                        value={formData.state}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select State</option>
                                        {statesList.map((state) => (
                                            <option key={state.id} value={state.id}>
                                                {state.name}
                                            </option>
                                        ))}
                                    </select>
                                    <div className="invalid-feedback">{errors.state}</div>
                                </div>

                                <div className="form-group mb-3 col-md-6">
                                    <label className="text-black font-w500">
                                        District <span className="text-danger">*</span>
                                    </label>
                                    <select
                                        name="district"
                                        className={`form-control ${errors.district ? "is-invalid" : ""
                                            }`}
                                        value={formData.district}
                                        onChange={handleChange}
                                        disabled={!formData.state}
                                        required
                                    >
                                        <option value="">Select District</option>
                                        {districtList.map((district) => (
                                            <option key={district.id} value={district.id}>
                                                {district.name}
                                            </option>
                                        ))}
                                    </select>
                                    <div className="invalid-feedback">{errors.district}</div>
                                </div>
                            </div>

                            {/* Admin Level + Block + Nyay Panchayat */}
                            <div className="row">
                                <div className="form-group mb-3 col-md-6">
                                    <label className="text-black font-w500">Admin Level</label>
                                    <select
                                        name="adminLevel"
                                        className="form-control"
                                        value={formData.adminLevel || ""}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select Level (optional)</option>
                                        <option value="district">District</option>
                                        <option value="block">Block</option>
                                        <option value="nyay_panchayat">Nyay Panchayat</option>
                                    </select>
                                </div>

                                {(formData.adminLevel === "block" || formData.adminLevel === "nyay_panchayat") && (
                                    <div className="form-group mb-3 col-md-6">
                                        <label className="text-black font-w500">
                                            Block <span className="text-danger">*</span>
                                        </label>
                                        <select
                                            name="block"
                                            className="form-control"
                                            value={formData.block || ""}
                                            onChange={handleChange}
                                            disabled={!formData.district}
                                        >
                                            <option value="">Select Block</option>
                                            {blockList.map(b => (
                                                <option key={b.id} value={b.id}>{b.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                )}

                                {formData.adminLevel === "nyay_panchayat" && (
                                    <div className="form-group mb-3 col-md-6">
                                        <label className="text-black font-w500">
                                            Nyay Panchayat <span className="text-danger">*</span>
                                        </label>
                                        <select
                                            name="nyayPanchayat"
                                            className="form-control"
                                            value={formData.nyayPanchayat || ""}
                                            onChange={handleChange}
                                            disabled={!formData.block}
                                        >
                                            <option value="">Select Nyay Panchayat</option>
                                            {nyayPanchayatList.map(np => (
                                                <option key={np.id} value={np.id}>{np.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                )}
                            </div>

                            <div className="row" style={{ display: 'none' }}>
                                {/* <div className="form-group mb-3 col-md-6">
                                    <label className="text-black font-w500">
                                        Assign Role <span className="text-danger">*</span>
                                    </label>
                                    <select
                                        name="adminCateogry"
                                        className={`form-control ${errors.adminCateogry ? "is-invalid" : ""
                                            }`}
                                        value={formData.adminCateogry}
                                        onChange={handleChange}
                                        // disabled={!formData.adminCateogry}
                                        required
                                    >
                                        <option value="">Select Assign Role</option>
                                        {accountUserAssingData?.data?.map((item) => (
                                            <option key={item.id} value={item?.id}>
                                                {item?.role_name}
                                            </option>
                                        ))}
                                    </select>
                                    <div className="invalid-feedback">{errors.adminCateogry}</div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer d-flex justify-content-between">

                    <Button
                        type="button"
                        className="btn btn-secondary mx-2"
                        onClick={handleClose}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="submit"
                        className="btn btn-primary mx-2"
                        disabled={Object.keys(errors).length > 0 || loading}
                    >
                        {loading ? "Adding..." : "Add"}
                    </Button>
                </div>
            </form>
        </Modal>
    );
};

export default AddAcountManagement;
